import React, { useState } from 'react';
import { updateMe } from 'api';

/**
 * Profile edit floating window (modal).
 * Allows changing the username, email, and password.
 */
const ProfileModal = ({ me, onClose, onUpdated }) => {
  const [username, setUsername] = useState(me?.displayName || '');
  const [email, setEmail] = useState(me?.email || '');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    // When changing the password, both inputs must match.
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    // Send only the fields being changed (skip password when blank).
    const payload = { username: username.trim(), email: email.trim() };
    if (password) {
      payload.password = password;
    }
    try {
      setSubmitting(true);
      const updated = await updateMe(payload);
      onUpdated(updated);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" onMouseDown={onClose}>
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-person-gear me-2" aria-hidden="true"></i>
                  Profile
                </h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
              </div>
              <div className="modal-body">
                {error && (
                  <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
                    <i className="bi bi-exclamation-octagon-fill" aria-hidden="true"></i>
                    {error}
                  </div>
                )}
                <div className="mb-3">
                  <label htmlFor="profile-username" className="form-label text-muted-gh">Username</label>
                  <input
                    id="profile-username"
                    type="text"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="profile-email" className="form-label text-muted-gh">Email</label>
                  <input
                    id="profile-email"
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-1">
                  <label htmlFor="profile-password" className="form-label text-muted-gh">New password</label>
                  <input
                    id="profile-password"
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    minLength={8}
                    autoComplete="new-password"
                  />
                  <div className="form-text text-muted-gh">
                    Leave blank to keep current. At least 8 characters, including uppercase, lowercase, a number, and a symbol.
                  </div>
                </div>
                <div>
                  <label htmlFor="profile-password-confirm" className="form-label text-muted-gh">Confirm new password</label>
                  <input
                    id="profile-password-confirm"
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    minLength={8}
                    autoComplete="new-password"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-gh" onClick={onClose}>Cancel</button>
                <button type="submit" className="btn btn-gh-primary" disabled={submitting}>
                  {submitting ? 'Saving...' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileModal;
